import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Typo } from 'uikit/content';

import styles from '../styles/uikitStatusesStatus.module.scss';

const Status = ({
  variant,
  hasDot,
  className,
  text,
  testId,
}) => {
  const VARIANTS = {
    info: styles.info,
    success: styles.success,
  };

  return (
    <div
      className={classnames(styles.element, className, VARIANTS[variant])}
      data-testid={testId}
    >
      {hasDot && <div className={styles.dot} />}
      <Typo element="span" variant="s01">
        {text}
      </Typo>
    </div>
  );
};

Status.defaultProps = {
  variant: 'success',
  hasDot: true,
  className: '',
  text: '',
  testId: '',
};

Status.propTypes = {
  variant: PropTypes.oneOf(['success', 'info']),
  hasDot: PropTypes.bool,
  className: PropTypes.string,
  text: PropTypes.string,
  testId: PropTypes.string,
};

export default React.memo(Status);
